const apiLink = 'https://origin.diagorisk.com/api/1.0/';
export default apiLink